import { render, staticRenderFns } from "./NewEditCouncil.vue?vue&type=template&id=baad82ca&"
import script from "./NewEditCouncil.vue?vue&type=script&lang=ts&"
export * from "./NewEditCouncil.vue?vue&type=script&lang=ts&"
import style0 from "./NewEditCouncil.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports